import {Action, createReducer, on} from "@ngrx/store";
import * as storeActions from './store.actions'
import {CompanyInterface} from "../interfaces/company.interface";
import {RestaurantInterface} from "../interfaces/restaurant.interface";
import {
    CurrentRestaurantSubscriptionInterface
} from "../../app/global/billings/interfaces/current-restaurant-subscription.interface";

export interface StoreState {
    company: CompanyInterface;
    currentRestaurant: RestaurantInterface;
    restaurants: RestaurantInterface[],
    subscription: CurrentRestaurantSubscriptionInterface;
    host: string;
}

export const initialState: StoreState = {
    company: null,
    currentRestaurant: null,
    restaurants: [],
    subscription: null,
    host: 'https://fodimi.pl'
}

const _storeStateReducer = createReducer(
    initialState,
    on(storeActions.UpdateCompany, (state: StoreState, {data}) => ({
      ...state,
      company: {
        ...state.company,
        ...data
      }
    })),
    on(storeActions.ClearStore, (state: StoreState) => ({
        ...initialState,
    })),
    on(storeActions.SetCurrentRestaurant, (state: StoreState, {restaurant}) => ({
        ...state,
        currentRestaurant: restaurant,
    })),
    on(storeActions.SetRestaurants, (state: StoreState, {restaurants}) => ({
        ...state,
        restaurants,
        currentRestaurant: state.currentRestaurant || restaurants[0]
    })),
    on(storeActions.SetSubscription, (state: StoreState, {subscription}) => ({
        ...state,
        subscription,
    })),
    on(storeActions.SetHost, (state: StoreState, {host}) => ({
        ...state,
        host
    })),
);

export function storeStateReducer(state: StoreState, action: Action): StoreState {
  return _storeStateReducer(state, action);
}
